import React, { useState } from 'react';
import Header from './SubscriptionHeader';
import SubscriptionCard from './SubscriptionCard';
import SignUpUserHeader from "../../../components/header/SignUpUserHeader";
import CheckoutFormWrapper from '../../../components/stripe/CheckoutForm';
import './SubscriptionPage.css';

const SubscriptionPage = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isConfirming, setIsConfirming] = useState(false);

  const handleChoosePlan = (plan) => {
    setSelectedPlan(plan);
    setIsConfirming(true);
  };

  const handleGoBack = () => {
    setIsConfirming(false);
    setSelectedPlan(null);
  };

  return (
    <div style={{ minHeight: "100dvh", background: "#fefcfe" }}>
      <SignUpUserHeader />
      <div className="onboarding-step">
        <div className="subscription-page">
          {!isConfirming ? (
            <>
              <Header
                title="Choose Your Subscription"
                subtitle="Please select the payment option that best suits your needs. All options will take you directly to the secure payment provider platform. We have selected to use Stripe as our provider to ensure secure and efficient online protection of your data."
              />
              <div className="subscription-options">
                <SubscriptionCard
                  title="One Week Free Trial"
                  description="Trial our basic features free of charge, without having to provide your payment details."
                  price="FREE"
                  onClick={() => setSelectedPlan('price_id_for_free_plan')}
                  selected={selectedPlan === 'price_id_for_free_plan'}
                />
                <SubscriptionCard
                  title="Pay Monthly"
                  description="Access to all our features for free for the first month, then:"
                  price="£6.99/month"
                  onClick={() => setSelectedPlan('price_id_for_monthly_plan')}
                  selected={selectedPlan === 'price_id_for_monthly_plan'}
                />
                <SubscriptionCard
                  title="Pay Annually"
                  description="Get 12 months for the price of 10"
                  price="£69.90/year"
                  onClick={() => setSelectedPlan('price_id_for_annual_plan')}
                  selected={selectedPlan === 'price_id_for_annual_plan'}
                />
              </div>
              <button
                className="next-button"
                onClick={() => setIsConfirming(true)}
                disabled={!selectedPlan}
              >
                Next
              </button>
            </>
          ) : (
            <>
              <Header
                title="Confirm Your Subscription"
                subtitle="Ensure that you are happy with your chosen subscription and confirm below to proceed to payment."
              />
              <SubscriptionCard
                title={
                  selectedPlan === 'price_id_for_free_plan'
                    ? 'Free Two Month Trial'
                    : selectedPlan === 'price_id_for_monthly_plan'
                    ? 'Pay Monthly'
                    : 'Pay Annually'
                }
                description="Access to all our features for free for the first two months."
                price={
                  selectedPlan === 'price_id_for_free_plan'
                    ? 'FREE'
                    : selectedPlan === 'price_id_for_monthly_plan'
                    ? '£6.99/month'
                    : '£69.90/year'
                }
                selected
              />
              <div className="confirmation-buttons">
                <button onClick={handleGoBack}>Go Back</button>
                <CheckoutFormWrapper priceId={selectedPlan} userId="user_id_here" email="user_email_here" />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPage;
